import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const ChordProgression = ({position, effect, chosen, currentChord}) => { 
    let [selected, setSelected] = useState(undefined);
    let chords = [];
    let progression = effect.chordProgression;
    let chord = progression.getStartingChord();
    let _chord = progression.getChord(chord);
    chords.push(_chord);
    for (let i=0; i < effect.progressionLength-1; i++ ) {
        if (chord !== undefined) {
            let nextChord = progression.getNextChordEffect(chord, i);
            if (nextChord) {
                chords.push(nextChord);
                chord = nextChord.numeral;
            }
        }
    }

    useEffect(() => {
        if (position === selected) {
            setSelected(undefined);
        }
    }, [position, setSelected, selected]);

    const onClick = useCallback((chord, position) => {
        effect.position = position - 1;
        if (effect.position < 0) {
            effect.position = effect.progressionLength - 1;
        }
        effect.currentChord = chord.numeral;
        setSelected(position);
    }, [setSelected, effect]);

    const getClassName = useCallback((i) => {
        let className = "chord-part";
        if (selected === undefined && position === i) {
            className += " current";
        }
        if (selected === i) {
            className += " selected";
        }
        return className;
    }, [position, selected]);

    return (
        <div className="progression">
          {chords.map((x, i) =>
                      <div
                        onClick={() => onClick(x,i)}
                        className={getClassName(i)}>{x.prettyName}</div>)}
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChordProgression);
